<template>
 <div class="">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="年月:">
          <el-date-picker
            v-model="searchFrom.dataYearMonth"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :clearable="false"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamName" filterable placeholder="请选择" clearable @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-select v-model="searchFrom.driverName" filterable placeholder="请选择">
            <el-option v-for="item in sijiList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
          </div>
        </div>
        <!-- <div class="tongjiBox">
          <el-form-item style="margin-left:8px;">
            <p class="margin0" >
              拉运单数合计<span class="red">{{sum.wayCount}}</span>单，
              累计收入合计<span class="red">{{sum.totalIncome}}</span>元，
              累计支出合计<span class="red">{{sum.totalExpense}}</span>元，
              利润合计<span class="red">{{sum.profit}}</span>元，
              司机薪资成本合计<span class="red">{{sum.driverTripFee}}</span>元，
              路桥费合计<span class="red">{{sum.roadToll}}</span>元，
              司机保险合计<span class="red">{{sum.driverInsurance}}</span>元，
              司机补助合计<span class="red">{{sum.driverFee}}</span>元，
              能源支出合计<span class="red">{{sum.energy}}</span>元，
              维修保养支出合计<span class="red">{{sum.maintenance}}</span>元，
              车辆保险合计<span class="red">{{sum.vehicleInsurance}}</span>元，
              年检支出合计<span class="red">{{sum.annualInspection}}</span>元，
              折旧合计<span class="red">{{sum.depreciation}}</span>元，
              管理费合计<span class="red">{{sum.management}}</span>元，
              其他支出合计<span class="red">{{sum.other}}</span>元
            </p>
          </el-form-item>
        </div> -->
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" style="width: 100%" height="100%"  center border class="tableComent" show-summary :summary-method="getSummaries" @sort-change="syncTableLayout">
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="driverName" label="司机姓名" width="130" fixed></el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" min-width="160"></el-table-column>
        <el-table-column prop="teamName" label="所属小队" min-width="120" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="wayCount" width="150" sortable :sort-method="sortByNumber('wayCount')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="以装车时间为依据统计当月运单数（去掉同一车次其他运单）"
              placement="top"
            >
              <span>拉运趟数<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="signedWayCount" width="150" sortable :sort-method="sortByNumber('signedWayCount')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="以签收时间为依据统计当月运单数（去掉同一车次其他运单）"
              placement="top"
            >
              <span>签收趟数<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="totalMileage" label="驾驶里程(KM)" min-width="130" :formatter="emptyFn" sortable :sort-method="sortByNumber('totalMileage')"></el-table-column>
        <!-- 累计收入 -->
        <el-table-column prop="totalIncome" min-width="150" sortable :sort-method="sortByNumber('totalIncome')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="累计收入 = 该司机已签收运单不含税收入之和"
              placement="top"
            >
              <span>累计收入(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span style="color: #67C23A;">{{formatMoney(scope.row.totalIncome)}}</span>
          </template>
        </el-table-column>

        <!-- 累计支出 -->
        <el-table-column prop="totalExpense" min-width="150" sortable :sort-method="sortByNumber('totalExpense')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="累计支出 = 司机薪资成本 + 司机保险(商业险+个人社保) + 能源支出(油/气/电)+ 路桥费 + 维修保养支出 + 车辆保险 + 年检支出 + 车头折旧支出 + 挂车折旧支出 + 管理费分摊 + 其他支出"
              placement="top"
            >
              <span>累计支出(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span style="color: #F56C6C;">{{formatMoney(scope.row.totalExpense)}}</span>
          </template>
        </el-table-column>

        <!-- 利润 -->
        <el-table-column prop="profit" min-width="130" sortable :sort-method="sortByNumber('profit')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="利润 = 累计收入 - 累计支出"
              placement="top"
            >
              <span>利润(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 利润率 -->
        <el-table-column prop="profitMargin" min-width="130" sortable :sort-method="sortByNumber('profitMargin')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="利润率 = (利润 ÷ 累计收入) × 100%"
              placement="top"
            >
              <span>利润率(%)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 司机薪资 -->
        <el-table-column prop="driverTripFee" min-width="170" sortable :sort-method="sortByNumber('driverTripFee')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="司机薪资成本 =[（司机已签收运单含税运费 - 司机加油/气费 - 司机路桥费 - 司机个人社保 + 司机补助 + 司机奖惩）×（1 + 服务费率）÷ 1.06"
              placement="top"
            >
              <span>司机薪资成本(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 司机保险 -->
        <el-table-column prop="driverInsurance" min-width="150" sortable :sort-method="sortByNumber('driverInsurance')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="司机保险 = 司机商业险月分摊额 + 司机个人社保（仅交五险司机）"
              placement="top"
            >
              <span>司机保险(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 司机补助 -->
        <el-table-column prop="driverFee" min-width="140" sortable :sort-method="sortByNumber('driverFee')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="司机当月补助之和"
              placement="top"
            >
              <span>司机补助(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="driverFee" min-width="140" sortable :sort-method="sortByNumber('driverFee')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="当前司机费用之和"
              placement="top"
            >
              <span>司机费用(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column> -->
        <!-- 能源支出 -->
        <el-table-column prop="energyExpense" min-width="140" sortable :sort-method="sortByNumber('energyExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="能源支出 = 油费 + 气费 + 充电费（金额）"
              placement="top"
            >
              <span>能源支出(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 路桥支出 -->
        <el-table-column prop="roadTollExpense" min-width="140" sortable :sort-method="sortByNumber('roadTollExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="路桥费 = 当月过路费总额"
              placement="top"
            >
              <span>路桥支出(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 维修保养支出 -->
        <el-table-column prop="maintenanceExpense" min-width="160" sortable :sort-method="sortByNumber('maintenanceExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="维修保养 = 当月机修工工资总额 / 当月内修总工时数 * 当月车辆的内修工时数 + 外修费用 + 物料成本"
              placement="top"
            >
              <span>维修保养支出(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 车辆保险分摊 -->
        <el-table-column prop="vehicleInsuranceExpense" min-width="160" sortable :sort-method="sortByNumber('vehicleInsuranceExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="车辆保险 = [车辆甲保费 × （当月天数 ÷ 保单总天数） × 该司机在该车收入占比]+ [车辆乙] + [车辆丙]"
              placement="top"
            >
              <span>车辆保险分摊(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 物料支出 -->
        <!-- <el-table-column prop="materialExpense" min-width="150" sortable :sort-method="sortByNumber('materialExpense')">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="当前司机月度物料费用支出之和"
              placement="top"
            >
              <span>物料支出(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column> -->

        <!-- 年检支出 -->
        <el-table-column prop="annualInspectionExpense" min-width="140" sortable :sort-method="sortByNumber('annualInspectionExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="年检支出 = [车辆甲年检费 ×（当月天数 ÷ 年检总天数）× 该司机在该车收入占比]+ [车辆乙] + [车辆丙]"
              placement="top"
            >
              <span>年检支出(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 折旧分摊 -->
        <el-table-column prop="depreciationExpense" min-width="160" sortable :sort-method="sortByNumber('depreciationExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="车头折旧 = [车头甲（购车款 - 残值）÷ 总月数 × 该司机在该车收入占比]+ [车头乙] + [车头丙]"
              placement="top"
            >
              <span>车头折旧分摊(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="trailerDepreciationExpense" min-width="160" sortable :sort-method="sortByNumber('trailerDepreciationExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="挂车折旧 = [挂车甲（购车款 - 残值）÷ 总月数 × 该司机在该车收入占比]+ [挂车乙] + [挂车丙]"
              placement="top"
            >
              <span>挂车折旧分摊(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 管理费分摊 -->
        <el-table-column prop="managementExpense" min-width="150" sortable :sort-method="sortByNumber('managementExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="管理费 = 管理费总额 * 车辆收入占比"
              placement="top"
            >
              <span>管理费分摊(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 其他费用 -->
        <el-table-column prop="otherExpense" min-width="140" sortable :sort-method="sortByNumber('otherExpense')" :formatter="moneyFormatter">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="当前司机月度零散杂费支出之和"
              placement="top"
            >
              <span>其他费用(元)<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="firstWayTime" width="170" :formatter="emptyFn">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="以装车时间为依据统计当月最早一单装车时间"
              placement="top"
            >
              <span>首单时间<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="lastWayTime" width="170" :formatter="emptyFn">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="以装车时间为依据统计当月最晚一单装车时间"
              placement="top"
            >
              <span>末单时间<i class="el-icon-info"></i></span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <!-- <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { tDriverAccountingDetails } from '@/api/newTMS'
import { organizationTree, cDlists } from '@/api/vgs-driver2.0'
export default {
  props: {
    yearMonth: {
      type: String,
      default: ''
    }
    // detailId: {
    //   type: [String, Number],
    //   default: null
    // },
  },
  components: {
  },
  data () {
    return {
      emptyFn: emptyFn,
      h: 500,
      tableLayoutTimer: null,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        dataYearMonth: ''
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      XDList: [],
      sijiList: [],
      btnFlg: [],
      btnIdArr: ['01N02A0100', '01N02A0200'],
      currentMasterId: null
    }
  },
  // 添加 watch 监听 detailId 的变化
  watch: {
    yearMonth: {
      handler (newVal) {
        if (newVal) {
          this.searchFrom.pageNo = 1
          this.$set(this.searchFrom, 'dataYearMonth', newVal)
        }
      },
      immediate: true
    }
    // detailId: {
    //   handler (newVal) {
    //     if (newVal) {
    //       this.currentMasterId = newVal
    //       delete this.searchFrom.dataYearMonth
    //       this.getList()
    //     }
    //   },
    //   immediate: true
    // }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    // if (!this.detailId) {
    // 没有 detailId 时，设置默认年月
    // this.searchFrom.dataYearMonth = this.getNextMonth()
    this.searchFn()
    // }
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 176) + 'px'
    this.syncTableLayout()
    window.addEventListener('resize', this.syncTableLayout)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.syncTableLayout)
    if (this.tableLayoutTimer) {
      clearTimeout(this.tableLayoutTimer)
      this.tableLayoutTimer = null
    }
  },
  methods: {
    syncTableLayout () {
      const runLayout = () => {
        const table = this.$refs.table
        if (table && table.doLayout) {
          table.doLayout()
        }
      }

      this.$nextTick(() => {
        runLayout()

        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(runLayout)
        }

        if (this.tableLayoutTimer) {
          clearTimeout(this.tableLayoutTimer)
        }
        this.tableLayoutTimer = setTimeout(runLayout, 120)
      })
    },
    getNextMonth () {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    // 获取列表
    getList () {
      this.loading = true
      let params = { ...this.searchFrom }
      // 如果有 currentMasterId，传 masterId
      // if (this.currentMasterId) {
      //   params.masterId = this.currentMasterId
      //   delete params.dataYearMonth // 有 masterId 时不传年月
      // } else {
      //   delete params.masterId
      // }

      tDriverAccountingDetails(params).then(res => {
        this.tableList = res.list || res // 根据接口返回结构调整
        this.total = res.total || this.tableList.length
        this.sum = res.summary || {}
        this.loading = false
        this.syncTableLayout()
      }).catch(err => {
        this.loading = false
        this.$message.error(err.message)
      })
    },
    carChange (e) {
      if (e) {
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.name == e)
        this.sijiList = []
        // this.$set(this.searchFrom, 'driverId', '')
        this.$set(this.searchFrom, 'driverName', '')
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
      }
    },
    // 导出
    exportFn () {
      let params = { ...this.searchFrom }
      // if (this.currentMasterId) {
      //   params.masterId = this.currentMasterId
      //   delete params.dataYearMonth // 有 masterId 时不传年月
      // } else {
      //   delete params.masterId
      // }
      delete params.pageNo
      delete params.pageSize
      exportExcel(
        this.global.tmsPlus + '/tDriverAccountingDetail/detailExport',
        params,
        '单人核算明细列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (!this.searchFrom.dataYearMonth) {
        this.searchFrom.dataYearMonth = this.getNextMonth()
      }
      this.getList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        dataYearMonth: this.yearMonth || this.getNextMonth()
      }
      this.searchFn()
    },
    getSummaries ({ columns, data }) {
      const summaryProps = [
        'wayCount',
        'signedWayCount',
        'totalMileage',
        'totalIncome',
        'totalExpense',
        'profit',
        'profitMargin',
        'driverTripFee',
        'driverInsurance',
        'driverFee',
        'energyExpense',
        'roadTollExpense',
        'maintenanceExpense',
        'vehicleInsuranceExpense',
        'annualInspectionExpense',
        'depreciationExpense',
        'trailerDepreciationExpense',
        'managementExpense',
        'otherExpense'
      ]

      return columns.map((column, index) => {
        if (index === 0) {
          return '\u5408\u8ba1'
        }

        const prop = column.property || column.prop
        if (!summaryProps.includes(prop)) {
          return ''
        }

        if (prop === 'profitMargin') {
          const totalProfit = data.reduce((sum, row) => sum + this.toNumber(row.profit), 0)
          const totalIncome = data.reduce((sum, row) => sum + this.toNumber(row.totalIncome), 0)
          const profitMargin = totalIncome ? (totalProfit / totalIncome) * 100 : 0
          return `${profitMargin.toFixed(2)}%`
        }

        const total = data.reduce((sum, row) => sum + this.toNumber(row[prop]), 0)
        return this.formatSummaryValue(total, prop)
      })
    },
    formatSummaryValue (value, prop) {
      if (prop === 'wayCount') {
        return Number.isInteger(value) ? value : Number(value.toFixed(2))
      }
      if (prop === 'signedWayCount') {
        return Number.isInteger(value) ? value : Number(value.toFixed(2))
      }
      if (prop === 'totalMileage') {
        return Number(value.toFixed(2))
      }

      return this.formatMoney(value)
    },
    moneyFormatter (row, column, cellValue) {
      return this.formatMoney(cellValue)
    },
    formatMoney (value) {
      const number = this.toNumber(value)
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    sortByNumber (prop) {
      return (a, b) => this.toNumber(a[prop]) - this.toNumber(b[prop])
    },
    toNumber (value) {
      if (value === null || value === undefined || value === '') return 0

      const number = Number(String(value).replace(/,/g, '').replace(/%/g, ''))
      return Number.isNaN(number) ? 0 : number
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
/deep/.tableComent .el-table__footer-wrapper td,
/deep/.tableComent .el-table__fixed-footer-wrapper td {
  background: #f5f7fa;
  font-weight: bold;
  color: red;
}
/deep/.tableComent .el-table__body td .cell {
  white-space: nowrap;
}
</style>
